import React from 'react';
import { Container, Title, Icon } from './styles';
import { Props } from './types';

const Placeholder: React.FC<Props> = ({
  text = 'Sorry, we couldn’t find any order that fits with your search',
  noIcon = false,
}) => {
  return (
    <Container>
      {!noIcon && <Icon />}
      <Title>{text}</Title>
    </Container>
  );
};

export default Placeholder;
